// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_in-0";
export var actionModalContentContainer = "_in-1";
export var createTagButton = "_in-2";
export var footerContainer = "_in-7";
export var fullWidthDivider = "_in-3";
export var hasCreateTagButton = "_in-4";
export var noCreateTagButton = "_in-5";
export var tagsContainer = "_in-6";
export var tagsModalContentContainer = "_in-8";